<div class="home-title bg-light text-center py-6">
  <h4 class="m-0 text-bold">Bem-vindo(a), {{ primeiroNome || 'Usuário' }}</h4>
</div>

@if (isServicoRadioterapiaPreencher && onboardingCtaLoading) {
  <div class="cta-onboarding cta-onboarding-loading" role="status" aria-live="polite">
    <div class="cta-content">
      <span class="text-muted">Verificando status do cadastro de serviço…</span>
    </div>
  </div>
}
@if (isServicoRadioterapiaPreencher && !onboardingCtaLoading && showOnboardingPendente) {
  <div class="cta-onboarding">
    <div class="cta-content">
      <div class="cta-icon">
        <i class="fas fa-hospital-user" aria-hidden="true"></i>
      </div>
      <div class="cta-text">
        <strong>Cadastro do Serviço pendente</strong>
        @if (featuresEquipamentos) {
          <span>Conclua o cadastro para habilitar o gerenciamento de equipamentos e pacientes.</span>
        } @else {
          <span>Conclua o cadastro para enviar os dados institucionais ao MS.</span>
        }
      </div>
      <a class="btn btn-pri cta-btn" [routerLink]="['/servico-radioterapia/cadastro']">
        <i class="fas fa-arrow-right me-1" aria-hidden="true"></i>
        Iniciar Cadastro
      </a>
    </div>
  </div>
}
@if (isServicoRadioterapiaPreencher && !onboardingCtaLoading && showOnboardingEmAnalise) {
  <div class="cta-onboarding cta-em-analise">
    <div class="cta-content">
      <div class="cta-icon cta-icon-info">
        <i class="fas fa-clock" aria-hidden="true"></i>
      </div>
      <div class="cta-text">
        <strong>Cadastro do Serviço em análise</strong>
        <span>O cadastro foi enviado com sucesso. Aguarde a validação do Ministério da Saúde (até 48 horas).</span>
      </div>
      <a class="btn btn-sec cta-btn" [routerLink]="['/servico-radioterapia/cadastro']">
        <i class="fas fa-edit me-1" aria-hidden="true"></i>
        Atualizar cadastro
      </a>
    </div>
  </div>
}
@if (isServicoRadioterapiaPreencher && !onboardingCtaLoading && showOnboardingReprovado) {
  <div class="cta-onboarding cta-reprovado" role="alert">
    <div class="cta-content">
      <div class="cta-icon cta-icon-danger">
        <i class="fas fa-times-circle" aria-hidden="true"></i>
      </div>
      <div class="cta-text">
        <strong>Cadastro do Serviço reprovado</strong>
        <span>O Ministério da Saúde reprovou o cadastro.</span>
        @if (justificativaRejeicao) {
          <span class="cta-justificativa">
            <strong>Justificativa:</strong> {{ justificativaRejeicao }}
          </span>
        } @else {
          <span class="cta-justificativa text-muted">Consulte o histórico do cadastro para ver a justificativa.</span>
        }
      </div>
      <a class="btn btn-sec cta-btn" [routerLink]="['/servico-radioterapia/cadastro']">
        <i class="fas fa-edit me-1" aria-hidden="true"></i>
        Corrigir e reenviar
      </a>
    </div>
  </div>
}

<div class="home-container">
  <div class="row">
    <div class="col-12 col-lg-8 mb-4 mb-lg-0">
      @if (allMenuItems.length > 0) {
        <div class="menu-grid">
          @for (item of allMenuItems; track item.label) {
            <a
              class="menu-card"
              href="javascript:void(0)"
              (click)="navegarPara(item)"
              [attr.title]="item.label"
            >
              <div class="menu-card-icon">
                @if (item.icon) {
                  <i class="fas" [ngClass]="item.icon" aria-hidden="true"></i>
                } @else {
                  <i class="fas fa-file-alt" aria-hidden="true"></i>
                }
              </div>
              <span class="menu-card-label">{{ item.label }}</span>
            </a>
          }
        </div>
      } @else {
        <div class="empty-menu">
          <i class="fas fa-exclamation-circle fa-3x mb-3" aria-hidden="true"></i>
          <p>Nenhuma funcionalidade disponível para o seu perfil.</p>
          <p class="text-muted">Entre em contato com o administrador do sistema.</p>
        </div>
      }
    </div>

    <div class="col-12 col-lg-4">
      <div class="info-card">
        <h5 class="info-title">
          <i class="fas fa-info-circle" aria-hidden="true"></i>
          SIMRAD — Serviço de radioterapia
        </h5>
        <p class="info-text">
          O SIMRAD é a plataforma nacional para cadastro e gestão do serviço de radioterapia em
          estabelecimentos habilitados (CACONs, UNACONs e prestadores de Radioterapia para o SUS).
          @if (featuresEquipamentos) {
            <span> Acompanhe equipamentos e o fluxo de cadastro com segurança e rastreabilidade.</span>
          } @else {
            <span> Acompanhe o fluxo de cadastro com segurança e rastreabilidade.</span>
          }
        </p>
        <p class="info-contato">
          Dúvidas entrar em contato através do
          <a href="mailto:simrad.decan@saude.gov.br">simrad.decan&#64;saude.gov.br</a>
        </p>
      </div>
    </div>
  </div>
</div>
